// extracted by mini-css-extract-plugin
export default {"entry":"modelConfig_entry__TIoND","header":"modelConfig_header__qTGH1","table":"modelConfig_table__F-Klt"};